import script from "./Filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./Filters.vue?vue&type=script&setup=true&lang=ts"

import "./Filters.vue?vue&type=style&index=0&id=b68a28d2&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b68a28d2"]])

export default __exports__